import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { authenticateImpersonationFn } from '@/auth/impersonation';
import { getAuthRedirectTarget } from '@/auth/redirects';

/** @internal */
export const impersonationSearchSchema = z.object({
  stytch_token_type: z.string().optional().catch(undefined),
  token: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/authenticate')({
  validateSearch: impersonationSearchSchema,
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  beforeLoad: async ({ search }) => {
    if (search.stytch_token_type !== 'impersonation' || search.token == null) {
      throw redirect({ to: getAuthRedirectTarget() });
    }

    await authenticateImpersonationFn({ data: { token: search.token } });
    throw redirect({ to: '/' });
  },
  component: () => null,
});
